import React, { useEffect } from "react";
import Hero from "../common/components/Hero";
import ContactForm from "./ContactForm";
import Map from "./Map";
import SocialConfect from "./SocialConfect";

const ContactUs = () => {
  useEffect(() => {
    document.getElementById("title-page").innerHTML =
      "Make My Way | Contact Us";
  }, []);
  return (
    <div className="pb-48">
      <Hero value={9} />
      <div className="w-full py-10 sm:py-14 md:py-20 lg:py-24 xl:py-[140px] px-4">
        <div className="w-full max-w-[1140px] mx-auto flex items-center justify-between 2xl:max-w-[1280px] max-xl:flex-col max-xl:gap-20 max-lg:gap-10">
          <ContactForm />
          <div className="w-full max-2xl:max-w-[511px] 2xl:w-5/12 flex flex-col justify-center max-xl:max-w-[680px]">
            <Map />
            <SocialConfect />
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default ContactUs;
